import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { QuestionnaireView } from '../views/QuestionnaireView';
import { useQuestionnaire } from '../hooks/useQuestionnaire';
import { LoadingSpinner } from '../components/LoadingSpinner';

export function QuestionnaireContainer() {
  const navigate = useNavigate();
  const { user, isLoading: authLoading } = useAuth();

  const {
    currentQuestionNumber,
    totalQuestions,
    question,
    isHarmonic,
    handleAnswer,
    goToNext,
    goToPrevious,
    currentAnswer,
    canGoBack,
    draftProgress,
    resumeDraft,
    discardDraft,
  } = useQuestionnaire();

  useEffect(() => {
    if (!authLoading && !user) {
      navigate('/login');
    }
  }, [user, authLoading, navigate]);

  if (authLoading) {
    return <LoadingSpinner message="Loading assessment..." />;
  }

  if (draftProgress !== null) {
    return (
      <div className="min-h-screen freud-bg flex items-center justify-center px-6">
        <div className="freud-card-elevated p-10 max-w-md w-full text-center">
          <div className="w-14 h-14 bg-sage-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <svg className="w-7 h-7 text-sage-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          </div>
          <h2 className="freud-heading-xl text-chocolate-900 mb-3">Resume Assessment?</h2>
          <p className="freud-text-base text-chocolate-500 mb-8">
            You have a saved assessment in progress — question {draftProgress + 1} of {totalQuestions} completed. Would you like to continue where you left off?
          </p>
          <div className="flex flex-col gap-3">
            <button
              onClick={resumeDraft}
              className="freud-btn-primary w-full"
            >
              Continue where I left off
            </button>
            <button
              onClick={discardDraft}
              className="freud-btn-secondary w-full"
            >
              Start from the beginning
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!question) {
    return <LoadingSpinner message="Loading assessment..." />;
  }

  return (
    <QuestionnaireView
      currentQuestion={currentQuestionNumber}
      totalQuestions={totalQuestions}
      question={question}
      isHarmonic={isHarmonic}
      handleAnswer={handleAnswer}
      goToNext={goToNext}
      goToPrevious={goToPrevious}
      currentAnswer={currentAnswer}
      canGoBack={canGoBack}
    />
  );
}
